import { useCallback, useEffect, useState } from 'react';
import { listBookings } from '../../services/bookings';

export default function useBookings() {
  const [bookings, setBookings] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      setBookings(await listBookings());
      setError('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return { bookings, error, loading, reload };
}